import { render, staticRenderFns } from "./auto-form-input.vue?vue&type=template&id=0bd0649a&scoped=true&"
import script from "./auto-form-input.ts?vue&type=script&lang=ts&"
export * from "./auto-form-input.ts?vue&type=script&lang=ts&"
import style0 from "./auto-form-input.scss?vue&type=style&index=0&id=0bd0649a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0649a",
  null
  
)

export default component.exports